import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx"
import Request1cModel from "../../model/Request1cModel";
import {ISelect} from "../../interface/ISelect";
import moment from "moment";

export class PageRegAllStore {
    private rootStore: RootStore | undefined;

    public cityOption: ISelect[] = [];
    public citySelected: ISelect = {
        label: 'Введите город, населенный пункт',
        value: ''
    };

    public cityError = '';

    public inputs = {
        fullNameOrg: {
            code: 'fullNameOrg',
            type: "text",
            title: 'Название организации*',
            tooltip: 'Название организации*',
            error: '',
            value: '',
            server: true,
        },
        unp: {
            code: 'unp',
            type: "text",
            title: 'УНП*',
            tooltip: 'УНП*',
            error: '',
            value: '',
            server: true,
            isMask: true,
            mask: '*99999999'
        },
        email: {
            code: 'email',
            type: "email",
            title: 'Адрес электронной почты (логин)*',
            tooltip: '@ домен почтового клиента*',
            error: '',
            value: '',
            server: true,
        },
        password: {
            code: 'password',
            type: "password",
            title: 'Пароль*',
            tooltip: 'Пароль*',
            error: '',
            value: '',
            server: true,
        },
        password2: {
            code: 'password2',
            type: "password",
            title: 'Повторите пароль*',
            tooltip: 'Повторите пароль*',
            error: '',
            value: '',
        },
        contactFIO: {
            code: 'contactFIO',
            type: "text",
            title: 'Контактное лицо(ФИО)*',
            tooltip: 'Контактное лицо(ФИО)*',
            error: '',
            value: '',
            server: true,
        },
        post: {
            code: 'post',
            type: "text",
            title: 'Должность*',
            tooltip: 'Должность*',
            error: '',
            value: '',
            server: true,
        },
        phone: {
            code: 'phone',
            type: "text",
            title: 'Телефон*',
            tooltip: 'Телефон*',
            error: '',
            value: '',
            server: true,
            isMask: true,
            mask: '+375 (99) 999-99-99'
        },
        tradePointAddress:{
            code: 'tradePointAddress',
            type: "text",
            title: 'Адрес одного из торговых объектов*',
            tooltip: 'Адрес одного из торговых объектов*',
            error: '',
            value: '',
            server: true,
        }
    };


    public error: string = '';
    public redirect: boolean = false;
    policy: boolean = false

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
        if (false && window.location.host === "localhost:3000") {
            this.inputs.fullNameOrg.value = 'ООО курская дуга';
            this.inputs.unp.value = 'Z12489756';
            this.inputs.email.value = 'luiwadjogs@fmail.com';
            this.inputs.password.value = 'qazWSX12';
            this.inputs.password2.value = this.inputs.password.value;
            this.inputs.contactFIO.value = 'Лесев Артур Динисович';
            this.inputs.post.value = 'Ген Директор';
            this.inputs.phone.value = '+375292417708';
        }
    }

    @action
    checkCity(isMessage = false) {
        let result = 0;
        let val = this.citySelected.value;
        if (!val && isMessage) {
            this.cityError = 'Выберите из списка!';
        } else {
            result = parseInt(val);
        }
        return result;
    }

    @action
    onSubmitForm(e: { preventDefault: () => void; }) {
        this.validationField()
            e.preventDefault();
            let data = [];
            for (let code in this.inputs) {
                // @ts-ignore
                let item = this.inputs[code];
                // @ts-ignore
                if (item.server) {
                    data.push(item);
                }
            }
            let dt: any = {};
            data.map((item: any) => {
                dt[item.code] = item.value;
                return item;
            });
            let id = this.checkCity(true);
            if (this.validate() && id) {
                let date = moment(Date()).format("YYYY-MM-DD HH:mm")
                dt['cityId'] = id;
                dt['type'] = 'clientReg';
                dt['isProcessed'] = false;
                dt['siteId'] = 1;
                dt['dateConfirmPersonalData'] = date;
                Request1cModel.createRegAll(
                    dt,
                    this.setSubmit,
                    this.setError
                );
            }
            return false;
    }


    @action validationField() {
        let result = true;
        let unp = this.inputs.unp
        let email = this.inputs.email
        let fullNameOrg = this.inputs.fullNameOrg
        let contactFIO = this.inputs.contactFIO
        let post = this.inputs.post
        let phone = this.inputs.phone
        let tradePointAddress = this.inputs.tradePointAddress
        console.log(unp.value.includes("_"))
        if (unp.value.includes("_")){
            unp.error = 'Длина УНП должна быть не менее 9 цифр';
        }else  {
            unp.error = '';
        }
        if (email.value.length === 0){
            email.error = 'Введите Ваш Email';
        }else {
            email.error = '';
        }
        if (fullNameOrg.value.length === 0){
            fullNameOrg.error = 'Введите название Вашей организации';
        }else {
            fullNameOrg.error = '';
        }
        if (contactFIO.value.length === 0){
            contactFIO.error = 'Введите ФИО контактного лица';
        }else {
            contactFIO.error = '';
        }
        if (post.value.length === 0){
            post.error = 'Введите должность';
        }else {
            post.error = '';
        }
        if (phone.value.length === 0){
            phone.error = 'Введите номер телефона';
        }else {
            phone.error = '';
        }
        if (tradePointAddress.value.length === 0){
            tradePointAddress.error = 'Введите адрес торгового объекта'
        }else {
            tradePointAddress.error = ''
        }
        if (unp.value.length < 9
            || email.value.length === 0
            || fullNameOrg.value.length === 0
            || contactFIO.value.length === 0
            || post.value.length === 0
            || phone.value.length === 0
            || tradePointAddress.value.length === 0
        ){
            result = false;
        }

    }
    @action validate() {
        let result = true;
        // PASSWORD
        let i1 = this.inputs.password;
        let i2 = this.inputs.password2;
        if (i1 !== undefined && i2 !== undefined) {
            if (i1.value !== i2.value) {
                i2.error = 'Неверное потверждение пароля!';
                result = false;
            } else {
                i2.error = '';
            }
        }

        if (i1.value.length < 8 ) {
            i1.error = 'Длина пароля должна быть больше 7';
            result = false;
        }
        if ( i1.value.length > 12) {
            console.log(i1.value.length)
            i1.error = 'Длина пароля должна быть меньше 13';
            result = false;
        }

        if (/^[^A-ZА-ЯЁ]*$/.test(i1.value)){
            i1.error = 'Пароль должен содержать хотябы одну заглавную букву';
            result = false;
        }
        if (/^[^~!@#$%^&*()_+]*$/.test(i1.value)){
            i1.error = 'Пароль должен содержать хотябы один спец символ ~ ! @ # $ % ^ & * ( ) _ +';
            result = false;
        }
        if (/^[^1234567890]*$/.test(i1.value)){
            i1.error = 'Пароль должен содержать хотябы одну цифру';
            result = false;
        }
        if (i1.value.length > 8 && i1.value.length < 12 && !/^[^A-ZА-ЯЁ]*$/.test(i1.value) && !/^[^~!@#$%^&*()_+]*$/.test(i1.value) && !/^[^1234567890]*$/.test(i1.value)){
            i1.error = '';
            result = true;
        }


        return result;
    }



    @action
    setSubmit = (result: any) => {
        this.redirect = true;
    }

    @action
    onChangeInput = (e: { target: { value: string; }; }, item: any) => {
        this.validationField()
        item.value = e.target.value;
        if (item.code === "password"|| item.code === "password2"){
            this.validate()
        }

    }

    @action
    onChangeInputCity = (e: ISelect) => {
        this.citySelected = e;
        this.cityError='';
    }


    @action
    onInputSelectChangeCity = (city: string) => {
        if (city.length > 2) {
            Request1cModel.getCity(city, this.setOptionCity, this.setError)
        }
    }

    @action setOptionCity = (result: any) => {
        this.cityOption = [];
        this.cityError='';
        result.data.map((city: any) => {
            this.cityOption.push({
                label: city.name,
                value: city.id,
            });
        })
    }
    @action setPolicy = (item: boolean) => {
      this.policy = item
    }
    @action showAlert = (item: boolean) => {
      if (!item){
          alert("Подтвердите согласие на обработку персональных данных")
      }
    }

    @action
    setError = (error: any) => {
        if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            error.response.data.message !== undefined
        ) {
            this.error = String(error.response.data.message);
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            Array.isArray(error.response.data)
        ) {
            let el = {
                error: ''
            };
            error.response.data.map((item: any) => {
                // @ts-ignore
                el = this.inputs[item.code];
                if (el !== undefined) {
                    el.error = item.error;
                }
                return item;
            });
        } else if (
            error !== undefined &&
            error.response !== undefined &&
            error.response.data !== undefined &&
            !Array.isArray(error.response.data)
        ) {
            return String(error.response.data);
        }
    }

}